import { selectPartnerAccess } from 'legacy/lut/features/partner360/configuration'
import { useSelector } from 'react-redux'

import { useFormField } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { MultiInputsControl } from 'partner360/components/multiInputsControl'
import { GlobalPartnerTypes } from 'partner360/widgets/gp360Administration'

import { TRANSLATION_KEYS } from '../../../../../../../../translations'
import { GLOBAL_PARTNER_FORM_KEY } from '../../../../configs'
import { isHpEmail } from '../../helpers/isHpEmail'
import { Label } from '../label/Label'

interface IGlobalFormPbmSelect {
  defaultValue: string[]
  globalPartnerType: GlobalPartnerTypes
}

export const GlobalFormPbmSelect = ({ defaultValue, globalPartnerType }: IGlobalFormPbmSelect) => {
  const { isDistributor } = useSelector(selectPartnerAccess)

  const { value, handleChange, validationMessage } = useFormField({
    defaultValue: defaultValue,
    formKey: GLOBAL_PARTNER_FORM_KEY,
    field: 'pbm',
    onValidate: isHpEmail,
    validationType: ValidationType.ONCHANGE,
  })

  const isDistributorTranslationKey = globalPartnerType === 'Distributor' || isDistributor

  return (
    <div>
      <Label
        isEmptyValue={!value.length}
        translation={
          isDistributorTranslationKey
            ? TRANSLATION_KEYS.globalPartnerForm.formFields.globalDbm
            : TRANSLATION_KEYS.globalPartnerForm.formFields.globalPbm
        }
        validationMessage={validationMessage}
      />
      <MultiInputsControl
        values={value}
        onChange={handleChange}
        placeholder="PBM"
        maxLen={3}
        minLen={1}
      />
    </div>
  )
}
